import { FC } from 'react'

import styled from 'styled-components'

import PlusIcon from 'src/Assets/Svg/roundedPlus.svg?react'
import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'

import { CTAButton } from '../Buttons/CTAButton'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 24px;
  width: 100%;
  padding: 24px;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.color.brandGreen};
  background: ${({ theme }) => theme.color.white};
  box-sizing: border-box;

  @media (min-width: ${MAX_MOBILE_WIDTH}) {
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
`

const Text = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI', sans-serif;
  line-height: 150%;
`

const Title = styled.p`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
`

const Description = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 400;
`

const StyledCTAButton = styled(CTAButton)`
  align-self: flex-start;
  padding: 8px 24px;
  flex-shrink: 0;

  @media (min-width: ${MAX_MOBILE_WIDTH}) {
    align-self: auto;
  }
`

export interface CreateCampaignBannerProps {
  title?: string
  description?: string
  buttonText?: string
  onCreateClick: () => void
  className?: string
}

export const CreateCampaignBanner: FC<CreateCampaignBannerProps> = ({
  title = 'Ready for your next campaign?',
  description = 'Your campaign has ended. Start a new one to keep your music moving and reach more listeners.',
  buttonText = 'Create campaign',
  onCreateClick,
  className,
}) => (
  <Container className={className}>
    <Text>
      <Title>{title}</Title>
      <Description>{description}</Description>
    </Text>
    <StyledCTAButton icon={<PlusIcon />} onClick={onCreateClick}>
      {buttonText}
    </StyledCTAButton>
  </Container>
)
